export function types (state) {
  return state?.schoolTypes?.data
}
